import store from 'store2';

interface ObjectControlParams {
  click?: boolean;
  addBasket?: boolean;
  payment?: boolean;
  feedId?: string;
  recType?: RecType;
}

type ObjectControl = ObjectControlParams & {
  timeshtamp: number;
};

const FEED_STATISTICS_LOCAL_STORAGE = '_clickstream_feed_statistic_';

const getProduct = (productId: string): ObjectControl => {
  const storage = store(FEED_STATISTICS_LOCAL_STORAGE);

  return storage ? storage[productId] : null;
};

const saveProduct = (
  productId: string,
  objectControlParams: ObjectControlParams
) => {
  const storage = store(FEED_STATISTICS_LOCAL_STORAGE) || {};
  storage[productId] = {
    click: false,
    addBasket: false,
    payment: false,
    ...getProduct(productId),
    ...objectControlParams,
    timeshtamp: Date.now(),
  };
  store(FEED_STATISTICS_LOCAL_STORAGE, storage);
};

export const addClick = (productId: string,  feedId: string, recType: RecType) => {
  saveProduct(productId, { click: true, feedId, recType });
};

export const addBasket = (productId: string): ObjectControlParams => {
  const productInStorage = getProduct(productId);
  if (productInStorage) {
    saveProduct(productId, { addBasket: true });
  }

  return { 
    feedId: productInStorage?.feedId,
    recType: productInStorage?.recType,
  };
};

export const addPayment = (productId: string): ObjectControlParams => {
  const productInStorage = getProduct(productId);
  if (
    productInStorage &&
    productInStorage.addBasket &&
    !productInStorage.payment
  ) {
    saveProduct(productId, { payment: true });
  }

  return { 
    feedId: productInStorage?.feedId,
    recType: productInStorage?.recType,
  };
};
